import { useData } from './useData';

export enum Modules {
    catalogMode = 'module_catalog_mode',
    paymentAndPickupAtStore = 'module_payment_and_pickup_at_store',
    googleAuth = 'module_google_auth',
    pointsGamification = 'module_points_gamification',
    rating = 'module_rating',
    coupon = 'module_coupon',
    favorite = 'module_favorite',
    map = 'module_map',
    map360 = 'module_360',
    image = 'module_image',
    zones = 'module_zone'
}

export const useModule = () => {
    const { allSettings } = useData();

    return {
        isModuleActive: (module: Modules) => {
            return (allSettings?.data && allSettings?.data[module as Modules]?.active) || false;
        },
        module360HasEmbed: () => {
            return (allSettings?.data && allSettings?.data['module_360']?.embed) || '';
        },
        moduleImageHasImage: () => {
            return (allSettings?.data && allSettings?.data['module_image']?.image) || null;
        },
    };
};
